import script from "./LozalizationDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./LozalizationDropdown.vue?vue&type=script&setup=true&lang=js"

import "./LozalizationDropdown.vue?vue&type=style&index=0&id=e279891a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e279891a"]])

export default __exports__